// extracted by mini-css-extract-plugin
export default {"title":"SortOrder_title__6LA90","toolbar":"SortOrder_toolbar__bV8QG","sortSelect":"SortOrder_sortSelect__q9fwL"};